/* src/app.js */
/* eslint-disable */

// Styles
// import "../node_modules/bootstrap/scss/bootstrap.scss";
import "./assets/styles/main-ltr.scss";



//import 'bootstrap';


// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/dropdown';
// import Swiper from 'swiper';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';

import 'bootstrap-select/js/bootstrap-select';

require('./assets/scripts/custom');


require('./assets/scripts/e-motion-validate');